import { agreeOnTerms } from '../utilities/api'

// ==================================================================================================
//
// Opt In Popup Functionality
//
// ==================================================================================================

const optInPopupBirthday = () => {
    let props = { isEnabled : false };
    let els = {};
    let agreeChecked = false

    // Cache dom element selectors
    // ------------------------------------------------
    const createChildren = () => {
      els.$optInMessage = $('#opt-in-accept')
      els.$hereButton    = $('#opt-in-accept').find('u')
      els.$optInPopupWrapper  = $('#optInPopupWrapper')
      els.$checkAcceptInput = els.$optInPopupWrapper.find('input')
      els.$cancelButton = $('#cancelX')
      els.$acceptButton = $('#acceptButton')
      els.$popupMessage = $('#popupMessage')
      els.$popupLink = els.$optInPopupWrapper.find('a')
      els.$checkAcceptInputWrapper = els.$optInPopupWrapper.find('.CCM--checkbox')
    }

    const showPopup = () => {
      els.$optInPopupWrapper[0].classList.add('shown');
      els.$acceptButton.addClass("active");
      els.$acceptButton.on('click', hidePopup())
    }

    const hidePopup = isWrapperClicked => e => {
        if (!e || e.target.id === 'optInPopupWrapper' || !isWrapperClicked) {
            els.$optInPopupWrapper[0].classList.remove('shown')

            // Reset checkbox and action button
            agreeChecked = false
            els.$checkAcceptInput.prop("checked", false);
            els.$acceptButton.removeClass("active")
        }
    }

    const submitPage = isWrapperClicked => e => {
        if (!e || e.target.id === 'optInPopupWrapper' || !isWrapperClicked) {
            els.$optInPopupWrapper[0].classList.remove('shown')

            // Reset checkbox and action button
            agreeChecked = false
            els.$checkAcceptInput.prop("checked", false);
            els.$acceptButton.removeClass("active");
        }
    }

    const togleAgreeCheckd = () => {
        agreeChecked = !agreeChecked

        agreeChecked ?
        els.$acceptButton.addClass("active") :
        els.$acceptButton.removeClass("active")
    }

    const setAgreed = () => {
        const memberId = els.$acceptButton.data('member-id')
        //agreeOnTerms(memberId, showTankYouNote)
        els.$popupLink.remove()
        els.$checkAcceptInputWrapper.remove()
        els.$optInMessage.remove()
        els.$acceptButton.remove()
        els.$cancelButton.on('click', hidePopup())

        //els.$acceptButton.on('click', hidePopup())
    }

    const showTankYouNote = () => {
        const webUrl = els.$optInPopupWrapper.data("web-url")
        els.$popupMessage.html(`Thanks! You have accepted the updated terms & conditions
            for reserving classes online. You may now continue to reserve classes online.
            A copy can be found <a class="inline" rel="noopener noreferrer" target="_blank" href="${webUrl}/terms-of-use#online-reservations">here.</a> Go forth and book!`
        )
        els.$popupLink.remove()
        els.$checkAcceptInputWrapper.remove()
        els.$optInMessage.remove()
        els.$acceptButton.remove()

        els.$acceptButton.on('click', hidePopup())
    }

    
    // Set up for responsive
    // ------------------------------------------------
    const setupResponsive = () => ({
        'sm' : enable,
        'md' : enable,
        'lg' : enable,
        'xl' : enable
    })

    // Enable
    // ------------------------------------------------
    const enable = () => {
				if (props.isEnabled) return;

        // Add your event handlers here
        els.$hereButton.on('click', showPopup)
        els.$cancelButton.on('click', hidePopup())
        els.$checkAcceptInput.on('click', togleAgreeCheckd)
        els.$acceptButton.on('click', submitPage())
        els.$optInPopupWrapper.on('click', hidePopup(true))

        props.isEnabled = true;

        return;
    }

    // Disable
    // ------------------------------------------------
    const disable = () => {
    if (!props.isEnabled) return;

    // Remove your event handlers here
    

    props.isEnabled = false;

    return;
    }

    // Init
    // ------------------------------------------------
    const init = () => {
        createChildren();
        setupResponsive();
        return;
    }

    return {
        init,
        enable,
        disable,
        responsiveCallbacks: setupResponsive()
    };
}


export default optInPopupBirthday;
